<!-- table表格 -->
<template>
  <a-table
    :loading="loading"
    :columns="columns"
    :data-source="tableData"
    :scroll="scroll"
    class="table-list"
    :rowKey="(record, index) => record.key || index"
    :pagination="pageInfo ? pageBean : false"
    @change="handleTableChange"
  >
    <template
      v-for="column in columns"
      :slot="column.scopedSlots ? column.scopedSlots.customRender : ''"
      slot-scope="text, record"
    >
      <a-tooltip placement="top">
        <template slot="title">{{ text }}</template>
        <div class="custom-title">{{ text }}</div>
      </a-tooltip>
      <slot
        :name="column.scopedSlots ? column.scopedSlots.customRender : ''"
        v-bind:scope="record"
      ></slot>
    </template>
  </a-table>
</template>

<script>
export default {
  name: "TableList",
  props: {
    // 表格各项
    columns: {
      type: Array,
      required: true,
    },
    // 列表数据
    tableData: {
      type: Array,
      required: true,
    },
    // 表格状态
    loading: {
      type: Boolean,
      required: true,
    },
    // 分页信息
    pageInfo: {
      type: Object,
      required: false,
    },
    // 滚动信息
    scroll: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 自定义分页
      pageBean: {
        current: 1, // 当前页数
        pageSize: 10, // 每页条数
        total: 0, // 数据总数
        showTotal: (total) =>
          `共 ${total} 条记录, 第 ${this.pageBean.current}/${Math.ceil(
            this.pageBean.total / this.pageBean.pageSize
          )} 页`,
        pageSizeOptions: ["10", "20", "30", "50"],
        showSizeChanger: true,
        showQuickJumper: true,
        loading: false,
      },
    };
  },
  computed: {},
  mounted() {},
  methods: {
    // 分页、排序、筛选变化时触发
    handleTableChange(pageBean, filters, sorter) {
      this.pageBean.pageSize = pageBean.pageSize;
      this.$emit("getList", pageBean, filters, sorter);
    },
  },
  watch: {
    pageInfo(newVal, oldVal) {
      if (JSON.stringify(newVal) != "{}") {
        this.pageBean.current = newVal.pageNum ? newVal.pageNum : 1;
        this.pageBean.pageSize = newVal.pageSize ? newVal.pageSize : 10;
        this.pageBean.total = newVal.total ? newVal.total : 0;
      }
    },
  },
};
</script>
<style scoped lang="less">
.table-list {
  border-top: 1px solid #e9edf1;
  :deep .ant-table-fixed-header .ant-table-scroll .ant-table-header {
    margin-bottom: -16px;
    padding-bottom: 0;
  }
}
</style>
